import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { IVolunteerAttendance } from './models';
import { invalidateVolunteerReporting } from './invalidateVolunteerReporting';
import { invalidateVolunteerRoster } from './useVolunteerRoster';

export const useEditAttendanceTimesMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: IVolunteerAttendance) => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({
			attendanceId,
			checkInAt,
			checkOutAt,
			impersonationContext,
		}: {
			attendanceId: string;
			activityId: string;
			checkInAt?: string;
			checkOutAt?: string;
			impersonationContext?: Api.IImpersonationContext;
		}) =>
			userSession.webServiceHelper.callAsync<IVolunteerAttendance>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `volunteering/attendance/${attendanceId}/times`,
				}),
				'PUT',
				{ checkInAt, checkOutAt }
			),
		onSuccess: (data, variables) => {
			invalidateVolunteerRoster(variables.activityId);
			invalidateVolunteerReporting();
			onSuccess?.(data);
		},
		onError,
	});
};
